import React from 'react';
import { NavLink } from 'react-router-dom';

interface Props {
  selectedDate: string;
}

export default function BookingsViewToggle({ selectedDate }: Props) {
  const search = `?date=${encodeURIComponent(selectedDate)}`;

  return (
    <nav className="bookings-view-toggle" aria-label="Bookings view">
      <NavLink
        to={{ pathname: '/bookings', search }}
        className={({ isActive }) => `bookings-view-toggle__item ${isActive ? 'bookings-view-toggle__item--active' : ''}`}
        aria-label="Booking management — PickleCourts requests, search, and history"
      >
        <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
          <path d="M7 5h10M7 10h10M7 15h10" />
          <circle cx="3.5" cy="5" r=".75" fill="currentColor" stroke="none" />
          <circle cx="3.5" cy="10" r=".75" fill="currentColor" stroke="none" />
          <circle cx="3.5" cy="15" r=".75" fill="currentColor" stroke="none" />
        </svg>
        <span className="bookings-view-toggle__copy">
          <strong>Booking management</strong>
          <small>PickleCourts requests & history</small>
        </span>
      </NavLink>
      <NavLink
        to={{ pathname: '/dashboard', search }}
        className={({ isActive }) => `bookings-view-toggle__item ${isActive ? 'bookings-view-toggle__item--active' : ''}`}
        aria-label="Availability and schedule — courts by day and time"
      >
        <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
          <rect x="2.5" y="3.5" width="15" height="14" rx="2" />
          <path d="M6 2v3M14 2v3M2.5 8h15M6 11h2M12 11h2M6 14h2M12 14h2" />
        </svg>
        <span className="bookings-view-toggle__copy">
          <strong>Availability & schedule</strong>
          <small>Courts by day & time</small>
        </span>
      </NavLink>
    </nav>
  );
}
